import evaluateDispensaryFeatureFlag from 'shared/utils/evaluate-dispensary-feature-flag';

export const MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG = 'ecomm.purchase-limits.multi-subcategory.rollout';

/**
 * Stores the raw LD value (not a coerced boolean) since apps/api evaluates this same
 * `.rollout` key as a per-dispensary JSON flag via getFeatureFlagByDispensary — reads
 * must go through the same evaluateDispensaryFeatureFlag logic or client/server can
 * desync (e.g. any truthy JSON object would read as "on" for every dispensary).
 */
let rawFlagValue: unknown = false;

export function setMultiSubcategoryPurchaseLimitsFlag(value: unknown): void {
  rawFlagValue = value;
}

export function isMultiSubcategoryPurchaseLimitsEnabled(dispensaryId = ''): boolean {
  return !!evaluateDispensaryFeatureFlag(MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG, rawFlagValue, dispensaryId);
}
